import { Reducer } from 'redux';
import * as ActionTypes from '../actions/types/CartActionTypes';
import { CreditCardView } from '../actions/types/CartActionTypes';

type CheckoutDataCodes = { code: string; code2?: string; fullName: string }[];

type CartState = {
  busy: boolean;
  cartId?: string;
  cartMessage?: string | null;
  checkoutData?: {
    cartId?: string;
    countryCodes?: CheckoutDataCodes;
    provinceCodes?: CheckoutDataCodes;
    stateCodes?: CheckoutDataCodes;
  };
  details?: {
    availableCredit?: number;
    canShip?: boolean;
    cashPaymentRequired?: boolean;
    checksum?: string;
    containsChangeTheDate?: boolean;
    expediteDisabled?: boolean;
    expediteHidden?: boolean;
    isOwnRegistry?: boolean;
    isRegistry?: boolean;
    isUsingCredits?: boolean;
    isWeddingDate?: boolean;
    maxApplicableCredit?: number;
    needEmail?: boolean;
    ownRegistry?: boolean;
    registrantNames?: string;
    registry?: boolean;
    registryId?: string;
    shipToName?: string;
    shippingProcessingToCost?: { code: string; cost: number; label: string }[];
    usingCredits?: boolean;
    weddingDate?: string | Date;
  };
  freeShipping?: { amountLeft: number; metThreshold: boolean } | null;
  initialized: boolean;
  isFreeShippingEligible?: boolean;
  items: any[]; // TODO: Define items
  promo?: string;

  /** @deprecated - this doesnt' appear to be read anywhere */
  size: number;
  totals: {
    subtotal?: number;
    tax?: number;
    deliverySurcharge?: number;
    supplyChainFee?: number;
    shipping?: number;
    creditApplied?: number;
    discountsApplied?: number;
    handlingFee?: number;
    total?: number;
    amountSaved?: number;
  };
  validateShipping?: boolean;

  // Saved card.. Just one... but its an array, so it will be accessed with card[0]
  card?: CreditCardView[];
};

const initialState = {
  details: {},
  busy: false,
  initialized: false,
  size: 0,
  items: [],
  totals: {},
  isFreeShippingEligible: false,
  validateShipping: true,
  freeShipping: null, // temporary
};

const cartReducer: Reducer<CartState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_CART: {
      return { ...state, busy: true };
    }
    case ActionTypes.RECEIVE_CART: {
      return {
        ...state,
        busy: false,
        initialized: true,
        cartMessage: action.payload.cartMessage,
        size: action.payload.items.length,
        items: action.payload.items,
        totals: action.payload.totals,
        isFreeShippingEligible: action.payload.is_free_shipping_eligible,
        freeShipping: action.payload.freeShipping,
      };
    }
    case ActionTypes.REQUEST_UPDATED_CART: {
      return { ...state, busy: true };
    }
    case ActionTypes.RECEIVE_UPDATED_CART: {
      return {
        ...state,
        cartMessage: action.payload.cartMessage,
        details: action.payload.details,
        items: action.payload.items,
        promo: action.payload.promo,
        totals: action.payload.totals,
      };
    }
    case ActionTypes.RECEIVE_DELETED_ITEMS: {
      return { ...state, deletedCartItems: action.payload };
    }
    case ActionTypes.RECEIVE_INITIAL_CART_DETAILS: {
      return {
        ...state,
        cartMessage: action.payload.cart.cartMessage,
        details: action.payload.cart.details,
        promo: action.payload.cart.promo,
        totals: action.payload.cart.totals,
        checkoutData: action.payload.checkoutData,
        cartId: action.payload.checkoutData && action.payload.checkoutData.cartId,
      };
    }
    case ActionTypes.RECEIVE_CREDIT_CARD: {
      return { ...state, card: action.payload };
    }
    case ActionTypes.RESET_CART: {
      return initialState;
    }
    case ActionTypes.UNLOAD_CART: {
      return { ...initialState, size: state.size };
    }
    case ActionTypes.RECEIVE_SHIPPING_VALIDATION: {
      const validateShipping =
        action.payload &&
        !action.payload.allowBypass &&
        (!action.payload.data || !action.payload.data.isValidating);
      const shippingError = action.payload.data && action.payload.data.userMessage;
      return {
        ...state,
        shippingError,
        validateShipping,
      };
    }
    default:
      return state;
  }
};

export default cartReducer;
